var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"bg-fff margin-top-20 padding-bottom-20"},[_c('header',{staticClass:"relation-title font-bold"},[_vm._v(_vm._s(_vm.$t("erp.b2c.associated_order",{defaultValue:'关联订单'})))]),_c('Table',{ref:"table",staticClass:"margin-10",attrs:{"columns":_vm.columns,"data":_vm.formList,"size":"small","border":"","stripe":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }